<div class="alert-list-container">
  <div class="alert-header">
    <h2>
      <mat-icon>notifications</mat-icon>
      Alerts
    </h2>
    <button mat-raised-button color="primary" (click)="loadAlerts()">
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
  </div>

  <!-- Filters -->
  <div class="alert-filters">
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="statusFilter" (selectionChange)="onFilterChange()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let status of statusOptions" [value]="status.value">
          {{ status.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Alert Type</mat-label>
      <mat-select [value]="alertTypeFilter" (selectionChange)="alertTypeFilter = $event.value; onFilterChange()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let type of alertTypes" [value]="type.value">
          {{ type.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-button (click)="clearFilters()">
      <mat-icon>clear</mat-icon>
      Clear Filters
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading alerts...</p>
  </div>

  <!-- Alerts List -->
  <div *ngIf="!loading" class="alerts-list">
    <div *ngFor="let alert of alerts" class="alert-card" [ngClass]="getSeverityClass(alert.severity)">
      <div class="alert-icon">
        <mat-icon [ngClass]="getSeverityClass(alert.severity)">
          {{ getSeverityIcon(alert.severity) }}
        </mat-icon>
      </div>
      <div class="alert-content">
        <div class="alert-header-row">
          <h3 class="alert-title">{{ alert.title }}</h3>
          <span class="alert-type-badge">{{ getAlertTypeLabel(alert.alert_type) }}</span>
        </div>
        <p class="alert-message">{{ alert.message }}</p>
        <div class="alert-meta">
          <span class="alert-date">
            <mat-icon>schedule</mat-icon>
            {{ alert.created_at | date: 'short' }}
          </span>
          <span class="alert-severity" [ngClass]="getSeverityClass(alert.severity)">
            {{ alert.severity | titlecase }}
          </span>
        </div>
      </div>
      <div class="alert-actions">
        <button *ngIf="alert.alert_type === 'boq_bid_received' && getInvitationId(alert)" 
                mat-raised-button 
                color="primary"
                (click)="viewBids(alert)">
          <mat-icon>visibility</mat-icon>
          View Bids
        </button>
        <button *ngIf="alert.alert_type === 'boq_bidding_invitation' && getBiddingLink(alert)" 
                mat-raised-button 
                color="primary"
                (click)="viewAndSubmitBid(alert)">
          <mat-icon>gavel</mat-icon>
          View & Submit Bid
        </button>
        <button *ngIf="alert.status === 'active' && !['boq_bidding_invitation','boq_bid_received','boq_bid_approved','boq_bid_declined'].includes(alert.alert_type)" 
                mat-raised-button 
                color="primary"
                (click)="acknowledgeAlert(alert)">
          <mat-icon>check_circle</mat-icon>
          Acknowledge
        </button>
        <button *ngIf="alert.status === 'active'" 
                mat-button 
                (click)="dismissAlert(alert)">
          <mat-icon>close</mat-icon>
          Dismiss
        </button>
        <span *ngIf="alert.status === 'acknowledged' && !['boq_bidding_invitation','boq_bid_received','boq_bid_approved','boq_bid_declined'].includes(alert.alert_type)" class="acknowledged-badge">
          <mat-icon>check_circle</mat-icon>
          Acknowledged
        </span>
      </div>
    </div>

    <div *ngIf="alerts.length === 0" class="no-alerts">
      <mat-icon>notifications_off</mat-icon>
      <p>No alerts found</p>
    </div>
  </div>

  <!-- Pagination -->
  <mat-paginator
    *ngIf="totalPages > 1"
    [length]="total"
    [pageSize]="limit"
    [pageIndex]="page - 1"
    [pageSizeOptions]="[10, 20, 50, 100]"
    (page)="onPageChange($event.pageIndex + 1)">
  </mat-paginator>
</div>
